"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyMap = exports.KeyCode = void 0;
exports.KeyCode = {
    Up: 38,
    Down: 40,
    Space: 32,
    Enter: 13,
    Esc: 27,
    Backspace: 8,
    Tab: 9,
};
exports.KeyMap = {
    Up: 'ArrowUp',
    Down: 'ArrowDown',
    Space: ' ',
    Enter: 'Enter',
    Esc: 'Escape',
    Backspace: 'Backspace',
    Tab: 'Tab',
};
